import { FrameWorkOptionTypes } from "@/components/ConfigurationComponents";
import useFetch from "./useFetch";

const useFrameworks = (slug?: string) => {
  const { data, error, mutate, isLoading } = useFetch("/v1/frameworks", {
    keepPreviousData: true,
    revalidateOnFocus: false,
  });

  const frameworks = (data?.data || []) as FrameWorkOptionTypes[];
  const framework = frameworks.find((item) => item.slug === slug);

  return {
    data: frameworks,
    framework,
    loading: isLoading,
    error: error,
    mutate,
  };
};
export default useFrameworks;
